import React, { useState, useEffect } from 'react';
import axios from 'axios';
import '@fortawesome/fontawesome-free/css/all.min.css';
import EnquiryModal from './EnquiryMode';
import { Link } from 'react-router-dom';
import './AllProducts.css'; // Add this CSS file

const AllProducts = ({ location }) => {
  const [products, setProducts] = useState([]);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [userData, setUserData] = useState(null);

  useEffect(() => {
    const vendortoken = window.localStorage.getItem("vendortoken");
    if (vendortoken) {
      fetch(`${process.env.REACT_APP_API_URL}/vendorData`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
        },
        body: JSON.stringify({ vendortoken }),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.status === "ok") {
            setUserData(data.data);
          } else {
            setError(data.message);
          }
        })
        .catch((error) => {
          console.error("Error:", error);
          setError(error.message);
        });
    }
    
    const fetchProducts = async () => {
      try {
        let url = `${process.env.REACT_APP_API_URL}/getProductsRelatedPlan`;
        if (location) {
          url = `${process.env.REACT_APP_API_URL}/getLocationRelatedProduct/${location}`;
        }
        const response = await axios.get(url);
        const data = response.data;

        if (data.status === 'ok') {
          setProducts(data.data);
          setMessage('');
        } else {
          setProducts([]);
          setMessage(data.message);
        }
      } catch (error) {
        setMessage('An error occurred: ' + error.message);
        setProducts([]);
      }
    };

    fetchProducts();
  }, [location]);

  const handleEnquiryClick = (product) => {
    setSelectedProduct(product);
    setShowModal(true);
  };

  const handleModalClose = () => {
    setShowModal(false);
    setSelectedProduct(null);
  };

  const handleWhatsAppClick = (product) => {
    const message = `Hi! I'm interested in ${product.name}. Please provide more details.`;
    const whatsappUrl = `https://wa.me/${product.vendorDetails.number}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };

  const formatPrice = (price) => {
    if (price) {
      return `₹${price.toLocaleString('en-IN')}`;
    }
    return 'Price on Request';
  };

  return (
    <div className="tradeindia-products-container">
      {message && <div className="alert alert-info">{message}</div>}
      {error && <div className="alert alert-danger">{error}</div>}
      
      <div className="products-grid">
        {products.map((product, index) => (
          <div key={index} className="tradeindia-product-card">
            {/* Product Image */}
            <div className="product-image-container--home ">
              <Link to={`/ProductView/${product._id}`}>
              {product.image?.length > 0 ? (
  <img
    src={`${process.env.REACT_APP_API_URL}/${product.image[0]?.replace('\\', '/')}`}
     className="product-image" 
                    alt={product.name}
                    loading="lazy"
  />
) : (
 <div className="no-image-placeholder">
                    <i className="fas fa-image"></i>
                    <span>No Image</span>
                  </div>
)}

              </Link>
              
              {/* Favorite Icon */}
              <div className="favorite-icon">
                <i className="far fa-heart"></i>
              </div>
            </div>

            {/* Product Details */}
            <div className="product-details">
              {/* Product Title */}
              <Link to={`/ProductView/${product._id}`} className="product-title-link">
                <h3 className="product-title">{product.name}</h3>
              </Link>

              {/* Price */}
              <div className="product-price">
                {formatPrice(product.price)}
                {product.unit && <span className="price-unit">/{product.unit}</span>}
              </div>

              {/* Company Details */}
              <div className="company-info">
                <div className="company-name">
                  <i className="fas fa-building company-icon"></i>
                  {product.vendorDetails.businessName}
                </div>
                <div className="company-location">
                  <i className="fas fa-map-marker-alt location-icon"></i>
                  {product.vendorDetails.City}, {product.vendorDetails.State}
                </div>
              </div>

              {/* Trust Indicators */}
              <div className="trust-indicators">
                <span className="verified-badge">
                  <i className="fas fa-check-circle"></i>
                  Verified Supplier
                </span>
                {product.gstNumber && (
                  <span className="gst-badge">
                    <i className="fas fa-certificate"></i>
                    GST Verified
                  </span>
                )}
              </div>

              {/* Action Buttons */}
              <div className="action-buttons">
                <div className="contact-info">
                  <div className="phone-number">
                    <i className="fas fa-phone"></i>
                    <span>{product.vendorDetails.number}</span>
                  </div>
                </div>
                
                <div className="button-group">
                  <button 
                    className="enquiry-btn"
                    onClick={() => handleEnquiryClick(product)}
                  >
                    <i className="fas fa-envelope"></i>
                    Send Inquiry
                  </button>
                  
                  <button 
                    className="whatsapp-btn"
                    onClick={() => handleWhatsAppClick(product)}
                  >
                    <i className="fab fa-whatsapp"></i>
                    WhatsApp
                  </button>
                </div>
              </div>

              {/* Additional Info */}
              <div className="additional-info">
                {product.minOrder && (
                  <div className="min-order">
                    <span className="info-label">Min. Order:</span>
                    <span className="info-value">{product.minOrder}</span>
                  </div>
                )}
                {product.category && (
                  <div className="category-tag">
                    <i className="fas fa-tag"></i>
                    {product.category}
                  </div>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Enquiry Modal */}
      <EnquiryModal 
        show={showModal} 
        handleClose={handleModalClose} 
        product={selectedProduct} 
        userData={userData}
      />
    </div>
  );
};

export default AllProducts;